import BaseComponent from "../../baseComponent.js";
import ColorUtil from "../../../core/utils/colorUtil.js";
import InternalEvent from "../../../core/constants/internalEvent";

export default class EditableRow extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  handleClick() {
    this.props.onClick(this.props.type, this.props.datasetRefId, this.props.fieldId);
  }

  handleDragStart(event) {
    event.dataTransfer.effectAllowed = "move";
    let mappingData = this.props.createMapping(this.props.type, this.props.datasetId, this.props.fieldId);
    let data = {
      dataset: {
        name: this.props.datasetRefId,
        persistenceId: this.props.datasetId,
        fieldId: this.props.fieldId
      },
      field: {
        fieldId: this.props.fieldId,
        name: this.props.fieldId
      },
      value: this.props.datasetRefId + "." + this.props.fieldId,
      formula: mappingData.formula,
      mappings: mappingData.mappings
    };
    event.dataTransfer.setData("data", JSON.stringify(data));
    this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START);
  }

  handleDragEnd(){
    this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END);
  }

  render() {
    var id = this.props.datasetRefId + "." + this.props.fieldId;
    var fieldIdCellStyle = {
      backgroundColor: this.props.color,
      borderColor: ColorUtil.shadeColor(this.props.color, -10)
    };
    return (
      <tr>
        <td className="studio-spreadsheet__field-id spreadsheet-selectable"
            style={fieldIdCellStyle}>
          <div draggable="true"
               onDragStart={this.handleDragStart}
               onDragEnd={this.handleDragEnd} style={{zIndex: 10}}>{this.props.fieldId}</div>
          <div data-ref={id} className="select-overlay"></div>
        </td>
        <td id={id} className="studio-spreadsheet__value spreadsheet-selectable" onClick={this.handleClick}>
          <div ref="value" style={{outline: "none"}}>
          </div>

          <div data-ref={id} className="select-overlay"></div>
        </td>
      </tr>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/editableRow.jsx